import { useSearchParams } from 'react-router';
import { ActivityTimeline } from '../activity/ActivityTimeline';
import type { ActivityFilterState } from '../activity/describe';
import { useAllAttachments } from './page/hooks';
import type { NetworkTabProps } from './tabProps';

/** The Activity tab (spec 11 6.15.13, 6.11): the network's timeline with its Kind and Person filters in the URL. */
export function NetworkActivityTab({ network }: NetworkTabProps) {
  const [search, setSearch] = useSearchParams();
  const n = network.data;
  const attachments = useAllAttachments(n.id);
  const deployments = new Set((attachments.data ?? []).map((a) => a.deploymentId));
  const filter: ActivityFilterState = {
    kind: search.get('kind') ?? '',
    actor: search.get('actor') ?? '',
    secret: '',
    resource: '',
  };
  const setFilter = (next: ActivityFilterState) => {
    const params = new URLSearchParams(search);
    params.set('tab', 'activity');
    for (const key of ['kind', 'actor'] as const) {
      if (next[key]) params.set(key, next[key]);
      else params.delete(key);
    }
    setSearch(params, { replace: true });
  };
  return (
    <ActivityTimeline
      network={{ id: n.id, name: n.name, deployments }}
      filter={filter}
      onFilterChange={setFilter}
      resources={[]}
    />
  );
}
